module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "o-container c-navigation"
  }, [_c('div', {
    staticClass: "o-layout o-layout--spacing-large"
  }, [_c('div', {
    staticClass: "o-layout__item u-10/12 u-offset-1/12 u-background-purple"
  }, [_c('div', {
    staticClass: "o-box o-box--spacing-small u-padding-horzontal-none u-type-white"
  }, [_c('ul', {
    staticClass: "o-list-inline o-list-inline--spacing-reduced o-list-inline--delimited-pipe"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      staticClass: "o-list-inline__item c-type-beta"
    }, [(_vm.externalPath(link)) ? _c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name))]) : _c('a', {
      attrs: {
        "href": link.path
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-719d6551","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/navigation.vue
// module id = 144
// module chunks = 1